// ----------------------------------------------------------------------

export default function Button(theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {

          '&:hover': {
            boxShadow: 'none',
          },
        },
        sizeLarge: {
          height: 48,
        },
        // contained
        containedInherit: {
          color: '#fff',
          boxShadow: theme.customShadows.z8,
          '&:hover': {
            backgroundColor: theme.palette.grey[400],
          },
        },
        containedPrimary: {
          color: '#fff',
         // backgroundColor: '#E5B261', // ou theme.palette.primary.main
          borderRadius: 9999, // capsule
          fontWeight: 700, // gras
          textTransform: 'none', // pour garder la casse
          paddingLeft: theme.spacing(4),
          paddingRight: theme.spacing(4),
          boxShadow: theme.customShadows.primary,
          '&:hover': {
            backgroundColor: '#d89d49', // version plus foncée au hover
          },
        },
        containedSecondary: {
          color: '#fff',
          boxShadow: theme.customShadows.secondary,
        },
        containedInfo: {
          color: '#fff',
          boxShadow: theme.customShadows.info,
        },
        containedSuccess: {
          color: '#fff',
          boxShadow: theme.customShadows.success,
        },
        containedWarning: {
          color: '#fff',
          boxShadow: theme.customShadows.warning,
        },
        containedError: {
          boxShadow: theme.customShadows.error,
        },
        // outlined
        outlinedInherit: {
          color: '#fff',
          border: `1px solid ${theme.palette.grey[500_32]}`,
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
        outlinedPrimary: {
          border: `1px solid ${theme.palette.primary.main}`,
        },
        outlinedSecondary: {
          color: '#fff',
          border: `1px solid ${theme.palette.secondary.main}`,
        },
        outlinedInfo: {
          color: '#fff',
          border: `1px solid ${theme.palette.info.main}`,
        },
        outlinedSuccess: {
          color: '#fff',
          border: `1px solid ${theme.palette.success.main}`,
        },
        outlinedWarning: {
          color: '#fff',
          border: `1px solid ${theme.palette.warning.main}`,
        },
        outlinedError: {
          color: theme.palette.error.main,
          border: `1px solid ${theme.palette.error.main}`,
        },
        // text
        textInherit: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
        textPrimary: {
          color: '#fff',
        },
        textSecondary: {
          color: '#fff',
        },
        textInfo: {
          color: '#fff',
        },
        textSuccess: {
          color: '#fff',
        },
        textWarning: {
          color: '#fff',
        },
        textError: {
          color: '#fff',
        },
      },
    },
  };
}